import { render, staticRenderFns } from "./seriesgoods.vue?vue&type=template&id=f890be66"
import script from "./seriesgoods.vue?vue&type=script&lang=js"
export * from "./seriesgoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports